import { environment } from '../../environments/environment';

interface QrFlagEnv { qrLoginEnabled?: boolean; }
const env: QrFlagEnv = environment;

/** QR girişi açık mı (125 yayın günü true). */
export const QR_LOGIN_ENABLED: boolean = env.qrLoginEnabled === true;
